/**
 * @description
 * Use attribute 'aria-describedby' for dismiss action.
 */
export var alertBaseBehavior = function alertBaseBehavior(props) {
  return {
    attributes: {
      dismissAction: {
        'aria-describedby': props.bodyId
      }
    }
  };
};
//# sourceMappingURL=alertBaseBehavior.js.map
